import React from 'react';
import PropTypes from 'prop-types';
import Currency from '../../../_utils/tools/currency';
import { PhotoDimensions, PrintSize } from '../../prop-types';
import ListQuantityFieldHandlers from '../../common/list-quantity-field-handlers';
import PhotoDpiNotice from '../../common/photo-quality/photo-dpi-notice';
import NumberInputField from '../../common/number-input-field';
import RecommendedPrintSizeBadge from '../../common/photo-quality/recommended-print-size-badge';

const ItemSize = ({
  rootId,
  sizeKey,
  title,
  options,
  area,
  rawDimensions,
  showLowQualityWarning,
  price,
  disabled,
  handleFormSubmit,
  handleQuantityChange,
  quantity,
  recommendedPrintSize,
}) => {
  const inputId = `size-quantity-change-${rootId}-${sizeKey}`;
  const isRecommended =
    recommendedPrintSize && recommendedPrintSize.key === sizeKey;

  return (
    <li>
      <form className="form-inline mb-2" onSubmit={handleFormSubmit}>
        <div className="list-item__size form-group flex-nowrap justify-content-end w-100">
          {isRecommended && <RecommendedPrintSizeBadge className="mr-2" />}
          {showLowQualityWarning && (
            <PhotoDpiNotice
              size_area={area}
              raw_dimensions={rawDimensions}
              noText
              tooltipPosition="left"
              tooltipCSSClasses="desktop"
              recommendedPrintSize={recommendedPrintSize}
            />
          )}
          {/* eslint-disable-next-line jsx-a11y/label-has-for */}
          <label aria-hidden="true" htmlFor={inputId}>
            {title}
          </label>
          {options["border"] &&
          <span className="list-item__size-border form-group flex-nowrap justify-content-end mr-2">Bordered</span>
          }
          <NumberInputField
            id={inputId}
            min={0}
            max={999}
            value={quantity()}
            label={sizeKey}
            disabled={disabled}
            onChange={handleQuantityChange}
          />
          <span className="price-each text-muted">
            {Currency.format(price)}&nbsp;ea
          </span>
        </div>
      </form>
    </li>
  );
};

ItemSize.propTypes = {
  sizeKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  options: PropTypes.object.isRequired,
  rootId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  area: PropTypes.arrayOf(PropTypes.number).isRequired,
  price: PropTypes.number.isRequired,
  rawDimensions: PhotoDimensions,
  showLowQualityWarning: PropTypes.bool,
  disabled: PropTypes.bool,
  handleFormSubmit: PropTypes.func.isRequired,
  handleQuantityChange: PropTypes.func.isRequired,
  quantity: PropTypes.func.isRequired,
  recommendedPrintSize: PrintSize,
};

ItemSize.defaultProps = {
  showLowQualityWarning: false,
  disabled: false,
  recommendedPrintSize: null,
  rawDimensions: null,
};

export default ListQuantityFieldHandlers(ItemSize);
